import React, { FC, MouseEventHandler } from 'react';
import {
  ImageButton,
  ImageWrapper,
  MoreMediaBox,
  PlayIconBox,
  ShowMoreControlsBox,
} from './styled';
import { PlayIcon } from '@/components';
import { Button, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

type SmallImageProps = {
  isVideoPlaceholder: boolean;
  onOpenVideoQuiet: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
  onOpenPhotoDetail: (index: number) => void;
  showMoreButton: boolean;
  hasVideo: boolean;
  index: number;
  photosCount: number;
  src: string;
};

export const SmallImage: FC<SmallImageProps> = ({
  isVideoPlaceholder,
  onOpenVideoQuiet,
  onOpenPhotoDetail,
  showMoreButton,
  hasVideo,
  index,
  photosCount,
  src,
}) => {
  const t = useTranslations();

  return (
    <ImageWrapper
      $maxHeight={'199px'}
      key={`small-${index}`}
      onClick={() => onOpenPhotoDetail(index + 1)}
    >
      {src && (
        <img
          src={src}
          alt={`preview image ${index + 2}`}
          fetchPriority={index === 0 ? 'high' : 'auto'}
        />
      )}

      {isVideoPlaceholder && (
        <ImageButton onClick={onOpenVideoQuiet} type="button" aria-label="Play video tour">
          <PlayIconBox aria-hidden="true">
            <PlayIcon />
          </PlayIconBox>
        </ImageButton>
      )}
      {showMoreButton && (
        <ImageButton type="button" aria-label="View all photos">
          <ShowMoreControlsBox>
            {!isVideoPlaceholder && hasVideo && index !== 3 && (
              <Button
                variant="primary"
                component="span"
                onClick={onOpenVideoQuiet}
                sx={{ height: '38px' }}
              >
                <Typography fontSize={14} fontWeight={600} lineHeight={'16px'}>
                  {t('housingCardDetails.videoTour')}
                </Typography>
              </Button>
            )}
            {photosCount > 0 && (
              <MoreMediaBox>
                <Typography fontSize={18} fontWeight={700} lineHeight={'20px'}>
                  {`+${photosCount}`}
                </Typography>
              </MoreMediaBox>
            )}
          </ShowMoreControlsBox>
        </ImageButton>
      )}
    </ImageWrapper>
  );
};
